
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPaperplane = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 92,
  width: 118,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 118 92"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M115.2 0q3.47 1.7 2.36 5.77Q99.98 70.6 97.23 80.04q-.72 2.49-2.99 4.21-1.72 1.3-3.33.55-2.33-1.08-19.84-10.15-.62-.32-.88-.73a.27.27 0 0 0-.49.06q-.1.31-.7.78-10.58 8.38-18.84 14.73-2.02 1.56-2.69 1.71c-2.84.63-4.27-2.33-5.12-4.87q-3.61-10.76-10.73-31.95a1.72 1.7 89.2 0 0-1.1-1.08Q15.84 48.66 2.8 44.46.7 43.78 0 41.12v-.81q.58-2.73 3.2-3.63Q33.01 26.51 113.66 0zM36.32 53 46.4 83.27a.36.35-44.1 0 0 .67.01l6.62-18.4a7.47 7.46 77.3 0 1 1.72-2.72L107.87 9.7a.14.14 0 0 0-.17-.22l-71.19 43a.45.44 65.7 0 0-.19.52M96.3 10.75 7.1 40.46a.14.14 0 0 0 0 .27l25.51 8.16a.92.91-51.6 0 0 .76-.09l62.94-38.02a.02.02 0 0 0-.01-.03m13.9 3.2L60.86 63.29a.46.46 0 0 0 .11.73L91.85 80a.36.35 20.6 0 0 .5-.22L110.29 14a.05.05 0 0 0-.09-.05M57.63 68.2l-4.6 12.78a.12.12 0 0 0 .18.13l11.75-9.09a.34.34 0 0 0-.05-.57l-6.71-3.48a.41.41 0 0 0-.57.23"
})));

      const __svgRaw = "<svg height=\"92\" width=\"118\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 118 92\" ><path fill=\"var(--theme-primary, #810ea9)\" d=\"M115.2 0q3.47 1.7 2.36 5.77Q99.98 70.6 97.23 80.04q-.72 2.49-2.99 4.21-1.72 1.3-3.33.55-2.33-1.08-19.84-10.15-.62-.32-.88-.73a.27.27 0 0 0-.49.06q-.1.31-.7.78-10.58 8.38-18.84 14.73-2.02 1.56-2.69 1.71c-2.84.63-4.27-2.33-5.12-4.87q-3.61-10.76-10.73-31.95a1.72 1.7 89.2 0 0-1.1-1.08Q15.84 48.66 2.8 44.46.7 43.78 0 41.12v-.81q.58-2.73 3.2-3.63Q33.01 26.51 113.66 0zM36.32 53 46.4 83.27a.36.35-44.1 0 0 .67.01l6.62-18.4a7.47 7.46 77.3 0 1 1.72-2.72L107.87 9.7a.14.14 0 0 0-.17-.22l-71.19 43a.45.44 65.7 0 0-.19.52M96.3 10.75 7.1 40.46a.14.14 0 0 0 0 .27l25.51 8.16a.92.91-51.6 0 0 .76-.09l62.94-38.02a.02.02 0 0 0-.01-.03m13.9 3.2L60.86 63.29a.46.46 0 0 0 .11.73L91.85 80a.36.35 20.6 0 0 .5-.22L110.29 14a.05.05 0 0 0-.09-.05M57.63 68.2l-4.6 12.78a.12.12 0 0 0 .18.13l11.75-9.09a.34.34 0 0 0-.05-.57l-6.71-3.48a.41.41 0 0 0-.57.23\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/paperplane.b15c4c694479c9151b532ed9606324a5.svg"),
        {
          React: SvgPaperplane,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      